const en = {
  app_applications_file_path: ".magento/applications.yaml",
  app_config_file: ".magento.app.yaml",
  app_environment_variable_name: "$MAGENTO_VARIABLES",
  app_name: "Adobe Commerce Cloud",
  app_routes_file_path: ".magento/routes.yaml",
  app_service_file_path: ".magento/service.yaml",
  app_services_file_path: ".magento/services.yaml",
  // Adobe keeps the pre-rename wording for this section (CON-1585). Upstream
  // renamed "Apps & Services" to "Containers" in CON-1287; Adobe asked for the
  // clearer label back in the Aug 2026 Console review. Routes are unchanged —
  // the URL stays /containers — so this is the label only, in the three places
  // it is shown: the environment sub-nav tab (tabs.containers, below), the
  // breadcrumb, and the heading above the container list.
  "breadcrumb.tabs.services": "Apps and Services",
  consent_description: "Authorize Adobe to use your account",
  containers: "Apps and Services",
  delete_branch_link:
    "https://experienceleague.adobe.com/docs/commerce-cloud-service/user-guide/develop/cli-branches.html?lang=en#delete-an-environment",
  // Troubleshooting drawer config-file references — Adobe uses the split
  // .magento config, not Upsun's .upsun/config.yaml. CON-1482.
  "drawer.troubleshooting.section2.file": ".magento.app.yaml",
  "drawer.troubleshooting.section5.outro.file": ".magento/services.yaml",
  "footer.message": "Version {appVersion} Powered by Upsun",
  // Adobe has no equivalent "search engine visibility" doc; empty string hides
  // the help sentence in the environment "Hide from search engines" setting
  // (IndexingSetting skips the block when this message is empty). CON-1471.
  "is_hidden.description2": "",
  "links.CLI_repository":
    "https://experienceleague.adobe.com/docs/commerce-cloud-service/user-guide/dev-tools/cloud-cli.html",
  no_access_environment_decativate_local_target:
    "Reach out to Support to deactivate your environment",
  "security_enforcement_banner.link":
    "See the <link>Adobe Commerce Security Enforcement Policy</link> for details.",
  "security_enforcement_banner.text":
    "Adobe’s Security Enforcement Policy sets firm deadlines of October 30, 2026 and May 31, 2027, by which the Adobe Commerce version, its software dependencies, or both must be upgraded. After the applicable deadline, Adobe may suspend traffic to the affected infrastructure — taking the storefront offline — and, if non-compliance continues, decommission the environment.",
  "services.noconfiguration":
    "Console does not currently output the content of sub-directory <code>.magento.app.yaml</code> files. To see your complete app configuration in Console, move the content of your <code>.magento.app.yaml</code> files to <code>.magento/applications.yaml</code>.",
  "settings.domains.add.body":
    "By default, your environment has a <i>.magentosite.cloud</i> URL. If you want to change the web address, you need to add a custom domain, such as <i>example.com.</i>.",
  "settings.variables.during_build":
    "<b>Available during buildtime:</b> Make this variable available during the build hook step of your <code>.magento.app.yaml</code>",
  "tabs.containers": "Apps and Services",
  "url.logo_url":
    "https://business.adobe.com/products/magento/magento-commerce.html"
};

export default en;
